<div class="auth-screen" style="background-color: #333 !important;">
    <nb-layout>

        <nb-layout-column class="light-bg" style="height: 100vh; width: 100vw;" *ngIf="environment?.name === 'rcdss'">
            <!-- <div class="row m-0 p-0"> -->
            <!-- <div class="col-md-8"> -->

            <div class="auth-form scroll">
                <div class="d-flex justify-content-center m-0">
                    <img src="./assets/images/rcdss/rcdss-logo.png" class="pr-4" style="width: auto; height: 115px;">
                    <div class="header-container d-flex d-row align-items-center">
                        <img src="./assets/images/rcdss/us-flag-justice.png"
                            style="width: auto; height: 115px; padding-right: 20px; opacity: 0.6;">
                        <div class="header-text d-block"
                            style="height: fit-content; font-family: 'Elephant', Poppins, Arial, sans-serif !important;">
                            <h4 class="m-0">County of Rockland</h4>
                            <h3 class="m-0 pl-4">Department of Social Services</h3>
                        </div>
                    </div>
                    <img src="./assets/images/rcdss/collaboration.png" class="pl-4" style="width: auto; height: 115px;">
                </div>
                <nb-card class="light-bg">
                    <nb-card-body class="info-content">
                        <div class="d-flex flex-row justify-content-center align-items-center pt-4 pb-4">
                            <img src="./assets/images/rcdss/welcome.png"
                                style="width: auto; height: 120px; color: #1D2F68; padding-right: 30px;">
                            <h2
                                style="padding-left: 30px; color: #1D2F68; font-family: 'Cooper Black', Poppins, Arial, sans-serif !important;">
                                To the DSS Funding<br>Opportunity Portal</h2>
                        </div>
                        <p class="m-0 pt-1" style="color: #1D2F68; font-weight: bold;">
                            The DSS Based Funding Opportunity Portal (DSSFOP) is a customized electronic document portal
                            <u>exclusively</u> for DSS contracts that allows non-profit agencies to upload their
                            applications for funding and all contract related documentation to a single location
                        </p>
                        <div class="alert alert-warning text-center mt-4">
                            <strong>FOR CONTRACTS WITH OTHER COUNTY DEPARTMENTS, VISIT:</strong>
                            <a
                                href="http://budget.rocklandgov.com/CAFunding.php">http://budget.rocklandgov.com/CAFunding.php</a>
                        </div>
                        <div class="row pt-4">
                            <div class="col-md-7">
                                <img src="./assets/images/rcdss/what-you-need-to-know.jpeg"
                                    style="width: auto; height: 180px; margin: auto; display: block; margin-bottom: 15px;">
                                <ul class="whats-new">
                                    <li>
                                        DSS will continue using its own Contract Portal
                                    </li>
                                    <li>
                                        Our Agencies will have individualized Contract Account for 2025 contracts
                                    </li>
                                    <li class="no-bullet">
                                        <ul class="ul-check-bullet pl-4">
                                            <li>
                                                User Registration Required for <u>first time Users</u>. All others log
                                                on with your current credentials.
                                            </li>
                                            <li>
                                                All correspondence and documents regarding <u>your</u> contract in one
                                                place!
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        Faster Contract Execution
                                    </li>
                                    <li>
                                        Easier Document Submission . . . . for:
                                    </li>
                                    <li class="no-bullet">
                                        <ul class="ul-check-bullet pl-4">
                                            <li>
                                                Funding Application
                                            </li>
                                            <li>
                                                Insurances
                                            </li>
                                            <li>
                                                Disclosure Statement
                                            </li>
                                            <li>
                                                Contract
                                            </li>
                                            <li>
                                                Vouchers
                                            </li>
                                            <li>
                                                Financial Reports . . . and more!
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        Helpful Calendar Reminders
                                    </li>
                                    <li>
                                        Improved Voucher Processing
                                    </li>
                                    <li>
                                        Financial Reports That Auto Populate Vouchers
                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-5">
                                <img src="./assets/images/rcdss/help-red-button.png"
                                    style="width: auto; height: 180px; margin: auto; display: block; margin-bottom: 15px">
                                <h4>
                                    <strong>Trainings</strong>
                                </h4>
                                <ul class="trainings-info">
                                    <li>
                                        Required for <u>first time</u> portal users only. You will be able to log in
                                        once you have participated in a required training.
                                    </li>
                                    <li>
                                        Helpful Training Guides and Videos are posted – view anytime once you logon!
                                    </li>
                                    <li>
                                        IT Help, See: <a class="text-primary"
                                            href="mailto:rcdss@ionsupply.com">rcdss@ionsupply.com</a>
                                    </li>
                                </ul>

                                <div class="d-flex flex-row">
                                    <img src="./assets/images/rcdss/new-for-2024.png"
                                        style="width: auto; height: 250px; margin: auto; display: block; margin-bottom: 15px">
                                    <h3 style="color: #0070c0;padding-top: 130px;">
                                        Autopopulated Electronic Vouchers & Improved Financial Reports Processed
                                        directly on ION.
                                    </h3>
                                </div>
                            </div>
                            <div class="col-md-12 py-4">
                                <div class="d-flex flex-row justify-content-between">
                                    <img src="./assets/images/rcdss/put-this-on-your-calendar.jpg"
                                        style="display: block; width: auto; height: 200px;">
                                    <img src="./assets/images/rcdss/deadlines-2024.png"
                                        style="display: block; width: auto; height: 120px; padding-top: 15px;">
                                    <img src="./assets/images/rcdss/dont-wait-submit-today.jpg"
                                        style="display: block; width: auto; height: 180px;">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-10 offset-md-1 bg-section">
                                <h4 style="color: #ffd507 !important; font-weight: 500;">
                                    COUNTY OF ROCKLAND
                                    <br>
                                    DEPARTMENT OF SOCIAL SERVICES
                                    <br>
                                    <small>and</small>
                                    <br>
                                    OUR CONTRACT AGENCIES
                                </h4>
                                <img src="./assets/images/rcdss/teamwork.png"
                                    style="width: auto; height: 100px; margin: 15px 0;">
                                <h4 style="color: #ffd507 !important; font-weight: 500;">
                                    WORKING TOGETHER FOR THE BENEFIT OF OUR COMMUNITIES
                                </h4>
                            </div>
                        </div>
                        <div class="row team">
                            <div class="col-md-6">
                                <img src="./assets/images/rcdss/meet-our-team.png"
                                    style="width: auto; height: 150px; max-width: 100%; display: block;margin: auto;">

                                <p class="pt-4">
                                    <strong>Fina Del Principio, Esq.</strong>
                                    <br>
                                    <i>Director, Legal Unit</i>
                                    <br>
                                    <span>Phone: (845) 364-3056</span>
                                </p>
                                <p>
                                    <strong>Jennifer Parietti, Esq.</strong>
                                    <br>
                                    <i>Assistant Director, Legal Unit</i>
                                    <br>
                                    <span>Phone: (845) 364-3912</span>
                                </p>
                            </div>
                            <div class="col-md-6">
                                <img src="./assets/images/rcdss/dss-contracts.png"
                                    style="width: auto; height: 170px; max-width: 100%; display: block;margin: auto;">

                                <p>
                                    <strong>Melissa Chappell</strong>
                                    <br>
                                    <i>Coordinator, Operations, Analysis & Planning Unit</i>
                                    <br>
                                    <span>Phone: (845) 364-3078</span>
                                </p>
                                <p>
                                    <strong>Wendy Gdanski</strong>
                                    <br>
                                    <i>Planning, Evaluation Specialist</i>
                                    <br>
                                    <span>Phone: (845) 364-3417</span>
                                </p>
                            </div>
                        </div>
                        <hr>
                        <div class="d-flex justify-content-between text-center m-0 pt-4">
                            <div>
                                <span>
                                    Ed Day
                                    <br>
                                    <small><i>County Executive</i></small>
                                </span>
                            </div>
                            <div class="d-flex flex-row align-items-center">
                                <img src="./assets/images/rcdss/rcdss-logo.png" style="width: auto; height: 50px;">
                                <h2>COUNTY OF ROCKLAND</h2>
                            </div>
                            <div>
                                <span>
                                    Joan M. Silvestri
                                    <br>
                                    <small><i>Commissioner of Social Services</i></small>
                                </span>
                            </div>
                        </div>
                    </nb-card-body>
                </nb-card>
            </div>
            <!-- </div> -->
            <!-- <div class="col-md-4"> -->

            <!-- </div> -->
            <!-- </div> -->

            <div class="login-btn-container">
                <button (click)="showLoginFormHandler()" type="button" class="btn btn-success login-btn"
                    [matTooltip]="'You will be able to login once you have participated in a required training'">Log
                    In</button>
            </div>


        </nb-layout-column>

        <nb-layout-column class="light-bg" style="max-width:500px; height:100vh;" *ngIf="environment?.name !== 'rcdss'">
            <div class="auth-form">
                <h1 class="auth-title">
                    <img src="./assets/images/ion_logobrand.png">
                </h1>

                <router-outlet></router-outlet>
            </div>
        </nb-layout-column>

        <nb-layout-column class="auth-screen" *ngIf="environment?.name !== 'rcdss'">
        </nb-layout-column>
    </nb-layout>
</div>